import { XMarkIcon } from "@heroicons/react/20/solid";
import { FolderIcon } from "@heroicons/react/24/outline";
import { Button } from "../../Catalyst/button";
import { Checkbox, CheckboxField } from "../../Catalyst/checkbox";
import { Label } from "../../Catalyst/fieldset";

interface BulkActionBarProps {
  selectedCount: number;
  isAllPagesSelected: boolean;
  onToggleAllPages: (selected: boolean) => void;
  onMove: () => void;
  onDeactivate: () => void;
  onDismiss: () => void;
}

// Floating bar shown while any rows are selected (Figma "Selection"). From lg
// up the 80px sidebar is visible, so the bar is centred within the content area.
const BulkActionBar = ({
  selectedCount,
  isAllPagesSelected,
  onToggleAllPages,
  onMove,
  onDeactivate,
  onDismiss,
}: BulkActionBarProps) => (
  <div
    role="region"
    aria-label="Bulk actions"
    className="fixed bottom-6 left-1/2 z-30 flex w-[min(860px,calc(100vw-32px))] -translate-x-1/2 lg:left-[calc(50%+40px)] lg:w-[min(860px,calc(100vw-120px))] flex-wrap items-center justify-between gap-3 rounded-xl border border-shadowborder bg-[#F9FAFB] px-4 py-3 shadow-[0px_12px_20px_0px_rgba(0,0,0,0.1)]"
  >
    <span className="desktext11 text-texthead">{selectedCount.toLocaleString("en-US")} selected</span>
    <div className="flex flex-wrap items-center gap-3">
      <CheckboxField className="rounded-lg border border-brColor bg-white px-3 py-2 shadow-light-sm">
        <Checkbox color="green" checked={isAllPagesSelected} onChange={onToggleAllPages} />
        <Label className="!text-sm !font-semibold text-textColor3">Select within all pages</Label>
      </CheckboxField>
      <Button outline onClick={onMove}>
        <FolderIcon />
        Move to organization
      </Button>
      <Button color="red" onClick={onDeactivate}>
        Deactivate
      </Button>
      <Button outline onClick={onDismiss} aria-label="Clear selection">
        <XMarkIcon />
      </Button>
    </div>
  </div>
);

export default BulkActionBar;
